import { gpeOneQuestions } from "./gpeTestContents";
import { gpeTwoQuestions } from "./gpeTestContents";
import { gpeThreeQuestions } from "./gpeTestContents";
import { gpeFourQuestions } from "./gpeTestContents";
import { gpeFiveQuestions } from "./gpeTestContents";

import { gpeOne } from "./gpeTestResponse";
import { gpeTwo } from "./gpeTestResponse";
import { gpeThree } from "./gpeTestResponse";
import { gpeFour } from "./gpeTestResponse";
import { gpeFive } from "./gpeTestResponse";

export const gpeReponses = {
  one: gpeOne,
  two: gpeTwo,
  three: gpeThree,
  four: gpeFour,
  five: gpeFive,
};

export const gpeQuestions = {
  one: gpeOneQuestions,
  two: gpeTwoQuestions,
  three: gpeThreeQuestions,
  four: gpeFourQuestions,
  five: gpeFiveQuestions,
};
